import { FuseAnimate, FusePageSimple } from "@fuse";
import _ from "@lodash";
import { Fab, withStyles } from "@material-ui/core";
import CatchErro from "app/Core/Components/CatchErro/CatchErro";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import withReducer from "app/store/withReducer";
import React from "react";
import { MdAdd } from "react-icons/md";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import EmpresaPessoaFolgaDialog from "./EmpresaPessoaFolgaDialog";
import EmpresaPessoaFolgaList from "./EmpresaPessoaFolgaList";
import * as Actions from "./Store/Actions/EmpresaPessoaFolgaActions";
import reducer from "./Store/Reducers/EmpresaPessoaFolgaReducer";

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
    },
    bgDiv: {
        backgroundColor: theme.palette.primary.main,
        border: "1px solid" + theme.palette.primary.main,
        borderRadius: "5px",
        marginBottom: "5px"
    },
    addButton: {
        position: "absolute",
        right: 20,
        bottom: 20,
        zIndex: 99
    }
});

const NewState = {
    open: null
};

class EmpresaPessoaFolgaApp extends XAPPComponent {

    state = { ...NewState };

    componentDidMount() {
        const { xappRouteParams, idparent, list, getTemplate } = this.props;
        list("SELECIONAR", xappRouteParams, idparent);
        getTemplate();
    }

    openDialog = (_AValue) => {
        this.setState(_.set({ ...this.state }, "open", _AValue));
    };

    render() {
        const { classes, xappRouteParams, idparent } = this.props;
        const form = this.state;
        return (
            <React.Fragment>
                <CatchErro
                    url={this.props.match.url}
                >
                    <FusePageSimple
                        classes={{
                            contentCardWrapper: "p-16 sm:p-24 pb-80",
                            leftSidebar: "w-256 border-0",
                            header: "hidden"
                        }}
                        content={
                            <React.Fragment>
                                <EmpresaPessoaFolgaList
                                    xappRouteParams={xappRouteParams}
                                    idparent={idparent}
                                    openDialog={this.openDialog}
                                />
                            </React.Fragment>
                        }
                        sidebarInner
                        onRef={instance => {
                            this.pageLayout = instance;
                        }}
                        innerScroll
                    />
                    <EmpresaPessoaFolgaDialog
                        xappRouteParams={xappRouteParams}
                        idparent={idparent}
                        openDialog={this.openDialog}
                        open={form.open}
                    />
                    <FuseAnimate animation="transition.expandIn" delay={300}>
                        <Fab
                            id={"fab-add-folga"}
                            color="primary"
                            aria-label="addFolga"
                            className={classes.addButton}
                            onClick={() => this.openDialog({ idpessoaformulario: null })}
                        >
                            <MdAdd className="text-24" />
                        </Fab>
                    </FuseAnimate>
                </CatchErro>
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
        save: Actions.save,
        getTemplate: Actions.getTemplate,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ Pessoa, EmpresaPessoaFolga }) {
    return {
        EmpresaPessoaFolga: EmpresaPessoaFolga,
        Pessoa: Pessoa.EmpresaPessoaReducer.formDialog.data,
    };
}

export default withReducer("EmpresaPessoaFolga", reducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaPessoaFolgaApp))));
